import React, { Component, Fragment } from "react"
import context from "../context"
import { compose } from "recompose"
import { withStyles } from "@material-ui/styles"
import styles from "../styles"
import SelectCrew from "../../../components/SelectCrew"
import {
  updateShootRole,
  deleteShootGlue,
  createCalendars,
  createMasterCalendar,
} from "../../../actions/shoots"
import CrewCard from "../../../components/CrewCard/index"
import update from "immutability-helper"
import {
  Button,
  Chip,
  Tooltip,
  Icon,
  IconButton,
  Popover,
  List,
  ListItem,
  ListItemText,
  Typography,
  CircularProgress,
} from "@material-ui/core"
import {
  toggleProfileDialog,
  toggleCreateUserDialog,
} from "../../../actions/users"
import { formatMoney } from "accounting"
import ChangeRateDialog from "../../../components/ChangeRateDialog/index"

const requestedChip = (role, classes) => {
  return (
    <Chip
      label={
        role.requested
          ? role.available
            ? "Confirmed"
            : "Requested"
          : "Not Requested"
      }
      style={{
        color: "white",
        marginTop: "8px",
      }}
      className={
        role.requested
          ? role.available
            ? classes.chipGreen
            : classes.chipYellow
          : classes.chipRed
      }
    />
  )
}

class One extends Component {
  state = {
    anchorEl: null,
    anchorId: null,
    changeRateOpen: false,
    editingRole: {},
    newRoleRate: "",
    savingRoleRate: false,
    percentage: 12,
    clientRate: 0,
    crewRate: 0,
  }

  componentDidMount() {
    this.props.setSelectUser(this.selectUser)
  }

  clearFields = () => {
    this.setState({
      percentage: 12,
      clientRate: 0,
      crewRate: 0,
    })
  }

  selectUser = (user, role, bool) => {
    let result = null
    if (typeof user === "number" || bool) {
      this.context
        .dispatch(
          updateShootRole(this.context.shoot.id, role.id, {
            user_id: user,
          })
        )
        .then(res => {
          result = res
          return Promise.all([
            this.context.dispatch(createCalendars(this.context.shoot.id)),
            this.context.dispatch(createMasterCalendar(this.context.shoot.id)),
          ])
        })
        .then(res => {
          this.props.setState(
            update(
              {
                shoot: this.context.shoot,
              },
              {
                shoot: {
                  $set: result,
                },
              }
            )
          )
        })
    } else {
      this.props.setState({ currentUpdateRole: role })
      this.context.dispatch(toggleCreateUserDialog(true, {}))
    }
  }

  setPopover = (e, func) => {
    this.props.setState(
      update(this.context, {
        popover: {
          anchor: {
            $set: e.currentTarget,
          },
          func: {
            $set: func,
          },
        },
      })
    )
  }
  // Not sure if Shoor is a typo
  updateShoorRoleData = (role, data) => {
    let newRes = null
    this.context
      .dispatch(updateShootRole(this.context.shoot.id, role.id, data))
      .then(res => {
        newRes = res
        return Promise.all([
          this.context.dispatch(createCalendars(this.context.shoot.id)),
          this.context.dispatch(createMasterCalendar(this.context.shoot.id)),
        ])
      })
      .then(res => {
        this.props.setState(
          update(
            {
              shoot: this.context.shoot,
            },
            {
              shoot: {
                $set: newRes,
              },
            }
          )
        )
      })
  }

  changeRate = role => {
    this.setState({
      savingRoleRate: true,
    })
    this.context
      .dispatch(
        updateShootRole(this.context.shoot.id, this.state.editingRole.id, {
          client_rate: this.state.clientRate,
          crew_rate: this.state.crewRate,
        })
      )
      .then(res => {
        this.props.setState(
          update(
            {
              shoot: this.context.shoot,
            },
            {
              shoot: {
                $set: res,
              },
            }
          )
        )
        this.setState({
          savingRoleRate: false,
          changeRateOpen: false,
          crewRate: 0,
          clientRate: 0,
          percentage: 12,
        })
      })
  }

  handleCloseChangeRate = () => {
    this.setState({ changeRateOpen: false })
    this.clearFields()
  }

  render() {
    const { context, state } = this
    const { shoot } = context
    const { anchorEl, anchorId, changeRateOpen, savingRoleRate } = state
    const { classes } = this.props

    return (
      <Fragment>
        <ChangeRateDialog
          open={changeRateOpen}
          handleCloseChangeRate={this.handleCloseChangeRate}
          clientRate={this.state.clientRate}
          crewRate={this.state.crewRate}
          percentage={this.state.percentage}
          setClientRate={e => this.setState({ clientRate: e })}
          setCrewRate={e => this.setState({ crewRate: e })}
          setPercentage={e => this.setState({ percentage: e })}
          submit={this.changeRate}
          submitting={savingRoleRate}
        />
        {shoot.roles.map((role, roleIndex) => {
          if (role.user_id) {
            const crew = context.crew.find(c => c.id === role.user_id)
            return crew ? (
              <div
                style={{
                  marginBottom: "16px",
                }}
                key={role.id}
              >
                <CrewCard
                  crew={crew}
                  isPositionSearch={false}
                  currentUser={context.authenticatedUser}
                  bottomArea={e => {
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          flexGrow: 1,
                        }}
                      >
                        <Tooltip
                          placement="top"
                          title="remove crew member from shoot"
                        >
                          <Button
                            onClick={e => {
                              this.setPopover(
                                e,
                                bool =>
                                  bool ? this.selectUser(null, role, true) : ""
                              )
                            }}
                            variant="contained"
                            color="secondary"
                          >
                            Cancel
                          </Button>
                        </Tooltip>
                        <div
                          className={classes.rateWrapper}
                          style={{ display: "flex" }}
                        >
                          <Tooltip title="Client Rate" placement="top">
                            <Typography variant="h6" className={classes.rate}>
                              {formatMoney(role.client_rate, "$", 0)}
                            </Typography>
                          </Tooltip>
                          <Tooltip title="Crew Rate" placement="top">
                            <Typography
                              variant="h6"
                              className={classes.rate}
                              style={{ fontSize: "16px", marginLeft: "8px" }}
                            >
                              {formatMoney(role.crew_rate, "$", 0)}
                            </Typography>
                          </Tooltip>
                        </div>
                        <IconButton
                          onClick={e =>
                            this.setState({
                              anchorEl: e.currentTarget,
                              anchorId: role.id,
                            })
                          }
                          style={{ transform: "translate(20px, 0)" }}
                        >
                          <Icon>more_vert</Icon>
                        </IconButton>
                        <Popover
                          open={
                            Boolean(anchorId) &&
                            anchorId === role.id &&
                            Boolean(anchorEl)
                          }
                          anchorEl={anchorEl}
                          onClose={e => {
                            this.setState({
                              anchorEl: null,
                              anchorId: null,
                            })
                          }}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                        >
                          <List style={{ cursor: "pointer" }}>
                            {!role.requested ? (
                              <Fragment>
                                <ListItem
                                  onClick={e => {
                                    this.updateShoorRoleData(role, {
                                      requested: true,
                                    })
                                    this.setState({
                                      anchorEl: null,
                                      anchorId: null,
                                    })
                                  }}
                                >
                                  <ListItemText>Mark as Requested</ListItemText>
                                </ListItem>
                                <ListItem
                                  onClick={e => {
                                    this.updateShoorRoleData(role, {
                                      requested: true,
                                      available: true,
                                    })
                                    this.setState({
                                      anchorEl: null,
                                      anchorId: null,
                                    })
                                  }}
                                >
                                  <ListItemText>Mark as Confirmed</ListItemText>
                                </ListItem>
                                <ListItem
                                  onClick={e => {
                                    this.setState({
                                      anchorEl: null,
                                      anchorId: null,
                                      changeRateOpen: true,
                                      editingRole: role,
                                    })
                                  }}
                                >
                                  <ListItemText>Change Rate</ListItemText>
                                </ListItem>
                              </Fragment>
                            ) : !role.available ? (
                              <React.Fragment>
                                <ListItem
                                  onClick={e => {
                                    this.updateShoorRoleData(role, {
                                      available: true,
                                    })
                                    this.setState({
                                      anchorEl: null,
                                      anchorId: null,
                                    })
                                  }}
                                >
                                  <ListItemText>Mark as Confirmed</ListItemText>
                                </ListItem>
                                <ListItem
                                  onClick={e => {
                                    this.updateShoorRoleData(role, {
                                      requested: false,
                                    })
                                    this.setState({
                                      anchorEl: null,
                                      anchorId: null,
                                    })
                                  }}
                                >
                                  <ListItemText>
                                    Mark as Not Requested
                                  </ListItemText>
                                </ListItem>
                              </React.Fragment>
                            ) : (
                              <ListItem
                                onClick={e => {
                                  this.updateShoorRoleData(role, {
                                    available: false,
                                  })
                                  this.setState({
                                    anchorEl: null,
                                    anchorId: null,
                                  })
                                }}
                              >
                                <ListItemText>
                                  Mark as not available
                                </ListItemText>
                              </ListItem>
                            )}
                          </List>
                        </Popover>
                      </div>
                    )
                  }}
                  topArea={e => {
                    return (
                      <div
                        style={{
                          position: "absolute",
                          zIndex: 1,
                          margin: "8px",
                          textAlign: "left",
                        }}
                      >
                        <Chip
                          label={role.name}
                          color="primary"
                          style={{ color: "white", cursor: "pointer" }}
                        />
                        <br />
                        {requestedChip(role, this.props.classes)}
                      </div>
                    )
                  }}
                  onOpenProfile={() =>
                    this.props.dispatch(
                      toggleProfileDialog(true, { id: crew.id })
                    )
                  }
                />
              </div>
            ) : (
              <CircularProgress style={{ margin: "100px" }} key={roleIndex} />
            )
          } else {
            return (
              <SelectCrew
                key={role.id}
                role={role}
                location={shoot.location}
                selectUser={user => this.selectUser(user, role)}
                removeRole={e => {
                  this.setPopover(e, bool => {
                    if (bool) {
                      this.props.setState(
                        update(this.context, {
                          shoot: {
                            roles: {
                              $splice: [[roleIndex, 1]],
                            },
                          },
                        })
                      )
                      this.props.dispatch(
                        deleteShootGlue(shoot.id, role.id, "roles")
                      )
                    }
                  })
                }}
              />
            )
          }
        })}
      </Fragment>
    )
  }
}

One.contextType = context

export default compose(withStyles(styles))(One)
